import { type UseQueryResult, useQuery } from 'react-query';
import { ConvertibleTransactionService } from '@wealthlane/api-services/wealthlane-captable-service';
import { type TableParams } from '../../types/common';

const useGetConvertibleTransactionList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParams,
  enabled?: boolean
): UseQueryResult<any, unknown> => {
  const {
    filter,
    sorting,
    skipCount,
    maxResultCount,
    _force,
  } = tableInfo;

  const parsedSkipCount = Number(skipCount);
  const parsedMaxResultCount = Number(maxResultCount);

  const normalizedSkipCount =
    Number.isFinite(parsedSkipCount) && parsedSkipCount >= 0 ? parsedSkipCount : 0;
  const normalizedMaxResultCount =
    Number.isFinite(parsedMaxResultCount) && parsedMaxResultCount > 0
      ? parsedMaxResultCount
      : 10;

  return useQuery(
    [
      'getConvertibleTransactionList',
      filter,
      sorting,
      normalizedSkipCount,
      normalizedMaxResultCount,
      _force,
    ],
    async () => {
      return await handleRequest(
        ConvertibleTransactionService.getApiCapTableApiAppConvertibleTransaction1(
          filter,
          sorting,
          normalizedSkipCount,
          normalizedMaxResultCount
        )
      );
    },
    {
      enabled: enabled !== false,
    }
  );
};

export default useGetConvertibleTransactionList;
